<div class="row-col row-col-xs team-list-layout" [ngClass]="{'detail-view' : showDetailView, 'list-expanded': listExpanded}"
     [class.list-pinned]="isListPinned">
  <div class="row-col employee-list light bg"
       [class.search-only]="selectedEmployee && !listExpanded"
       (click-outside)="onListClickOutside($event)">

    <!-- Search + filter bar — always visible -->
    <div class="emp-search-bar">
      <div class="search-input-group"
           [class.disabled]="isCustomTeam && listExpanded"
           (click)="onSearchFocus()"
           [tooltip]="isCustomTeam && listExpanded ? ('TEAM_PLANNING.search_disabled_custom_team' | translate) : ''"
           placement="bottom">
        <span class="search-icon"><i class="fa fa-light fa-search"></i></span>
        <input type="text"
               class="search-input"
               placeholder="{{ 'NAVBAR.search' | translate }}..."
               [formControl]="searchTermControl"
               [attr.disabled]="isCustomTeam && listExpanded ? '' : null"
               (focus)="onSearchFocus()"
               [attr.test-id]="'search-term'">
      </div>

      <!-- Filter / team selector -->
      <gp-dropdown-select #teamDropdown
                          class="emp-filter-select"
                          [ngModel]="selectedTeam"
                          [buttonClasses]="['emp-filter-btn']"
                          (ngModelChange)="onTeamChange($event)"
                          [attr.test-id]="'team-select'"
                          ngDefaultControl>
        <!-- Section: standard subordinate views -->
        <h6 class="dropdown-section-header">{{ 'TEAM_PLANNING.subordinates_header' | translate }}</h6>
        <gp-dropdown-option [ngValue]="0" [attr.test-id]="'direct-subordinates'">
          {{ 'TEAM_PLANNING.direct_subordinates' | translate }}
        </gp-dropdown-option>
        <gp-dropdown-option [ngValue]="1" [attr.test-id]="'indirect-subordinates'">
          {{ 'TEAM_PLANNING.indirect_subordinates' | translate }}
        </gp-dropdown-option>
        <gp-dropdown-option [ngValue]="2" [attr.test-id]="'future-subordinates'">
          {{ 'TEAM_PLANNING.future_subordinates' | translate }}
        </gp-dropdown-option>
        <gp-dropdown-option [ngValue]="3" [attr.test-id]="'backup-subordinates'">
          {{ 'TEAM_PLANNING.backup_subordinates' | translate }}
        </gp-dropdown-option>
        <gp-dropdown-option [ngValue]="4" [attr.test-id]="'all-subordinates'">
          {{ 'TEAM_PLANNING.all_subordinates' | translate }}
        </gp-dropdown-option>

        <!-- Section: custom teams -->
        <ng-container *ngIf="teams.length > 0">
          <hr class="dropdown-section-separator">
          <h6 class="dropdown-section-header">{{ 'TEAM_PLANNING.my_teams_header' | translate }}</h6>
          <gp-dropdown-option *ngFor="let team of teams" [ngValue]="team.id">
            {{ team.name }}
          </gp-dropdown-option>
        </ng-container>

        <!-- Section: actions -->
        <hr class="dropdown-section-separator">
        <button type="button"
                class="dropdown-action-btn dropdown-action-btn--create"
                (click)="openCreateTeamModal(); teamDropdown.open = false"
                [attr.test-id]="'create-new-team'">
          <i class="fa fa-light fa-plus" aria-hidden="true"></i>
          {{ 'TEAM_PLANNING.create_new_team' | translate }}
        </button>
        <button *ngIf="isCustomTeam"
                type="button"
                class="dropdown-action-btn dropdown-action-btn--delete"
                (click)="deleteTeam(); teamDropdown.open = false"
                [attr.test-id]="'delete-team'">
          <i class="fa fa-light fa-trash" aria-hidden="true"></i>
          {{ 'TEAM_PLANNING.delete_team' | translate }}
        </button>
      </gp-dropdown-select>
      <button *ngIf="!isMobileViewport"
              type="button"
              class="pin-toggle-btn"
              [class.active]="isListPinned"
              [attr.aria-pressed]="isListPinned"
              [attr.aria-label]="(isListPinned ? 'EMPLOYEE_LIST.unpin_list' : 'EMPLOYEE_LIST.pin_list') | translate"
              [tooltip]="(isListPinned ? 'EMPLOYEE_LIST.unpin_list' : 'EMPLOYEE_LIST.pin_list') | translate"
              placement="bottom"
              (click)="toggleListPin(); $event.stopPropagation()">
        <i class="fa fa-light fa-thumbtack" [class.fa-rotate-90]="!isListPinned" aria-hidden="true"></i>
      </button>
    </div>


    <!-- Count — only when the list is expanded -->
    <div class="emp-list-meta" *ngIf="employees.length && listExpanded">
      <span class="emp-count">
        <span class="count-badge">{{ employees.length }}</span>
        {{ 'EMPLOYEE_LIST.number' | translate }}
      </span>
    </div>

    <!-- Employee list — only when the list is expanded -->
    <div #employeeList class="row-body scrollable" [hidden]="!listExpanded">
      <div class="row-inner">
        <div class="emp-items">

          <div class="padding text-center" *ngIf="isLoading">
            <em class="fa fa-light fa-spinner fa-spin"></em>
          </div>

          <div class="emp-item"
               *ngFor="let employee of employees"
               (click)="select(employee)"
               [attr.data-empid]="employee.id"
               [attr.test-id]="employee.firstName + '-' + employee.lastName"
               [ngClass]="{
                 'active': isEmployeeSelected(employee),
                 'inactive': isInactive(employee?.empContracts)
               }">

            <!-- Avatar -->
            <div class="emp-item__avatar">
              <div class="emp-item__avatar-wrapper">
                <gp-user-avatar
                  [pictureUri]="getPicture(employee)"
                  [initials]="getEmployeeInitials(employee)"
                  size="sm"></gp-user-avatar>
              </div>
            </div>

            <!-- Info -->
            <div class="emp-item__info">
              <div class="emp-item__name">
                <span class="font-weight-bold">{{ employee.lastName }}</span>
                {{ employee.firstName }}
              </div>
              <div class="emp-item__sub" *ngIf="employee.employeeNumber">
                ({{ employee.employeeNumber }})
              </div>
              <div class="emp-item__id">
                <span class="emp-item__contract" *ngIf="employee.empContracts?.length">
                  {{ 'EMPLOYEE_FORM.Contract_name' | translate:{name: employee.empContracts[0]?.cliRegNickName} }}
                </span>
              </div>
              <div class="emp-item__position"
                   *ngIf="employee.empContracts?.length && employee.empContracts[0].position">
                {{ employee.empContracts[0].position }}
              </div>
              <div class="emp-item__dates" *ngIf="employee.empContracts?.length">
                {{ getContractDate(employee.empContracts[0]) }}
              </div>
            </div>

            <!-- Incomplete indicator -->
            <i class="fa fa-light fa-exclamation-circle emp-item__issue"
               *ngIf="!employee.completed && displayIncomplete"
               aria-hidden="true"></i>

            <!-- Per-employee actions menu -->
            <span class="emp-item__menu dropdown" #dd>
              <button class="btn btn-outline btn-menu" type="button"
                      [attr.test-id]="'employee-menu'"
                      (click)="onMenuClick({employee: employee, event: $event}); $event.stopPropagation()">
                <span class="fa fa-light fa-ellipsis-v"></span>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Overlay blocks the detail while the list is expanded over a selection -->
  <div class="emp-list-overlay"
       *ngIf="selectedEmployee && listExpanded && !isListPinned"
       (click)="collapseList()"></div>

  <!-- Detail -->
  <div class="employee-detail"
       [class.search-only]="selectedEmployee && !listExpanded"
       [class.list-open]="selectedEmployee && listExpanded">

    <gp-contract-data
      *ngIf="selectedEmployee && !isLoading"
      [cliEmpId]="selectedEmployee.id"
      [selectedContract]="selectedContract"
      [employeeFirstName]="selectedEmployee?.firstName"
      [employeeLastName]="selectedEmployee?.lastName"
      [photoLink]="selectedEmployee?.photoLink"
      [contracts]="contracts"
      [profileType]="mssProfileType"
      [workflowName]="workflowName"
      (backLinkClickEvent)="backLinkClickEventHandler()"
      [profileMode]="profileMode">
    </gp-contract-data>

    <div *ngIf="!selectedEmployee && employees.length > 0 && !isLoading" class="emp-detail-placeholder">
      <gp-illustrated-message
        class="m-t-lg"
        [width]="'70%'"
        [type]="'SEARCH'"
        [text]="'MSS.choose_contract'">
      </gp-illustrated-message>
    </div>
    <div *ngIf="employees.length === 0 && !isLoading" class="emp-detail-placeholder">
      <gp-illustrated-message
        class="m-t-lg"
        [width]="'70%'"
        [type]="'NO_CONTENT'"
        [text]="'PAYROLL_PREPARE.no_contract_found_for_employee'">
      </gp-illustrated-message>
    </div>
  </div>

</div>

<gp-modal gp-modal="create-team" [closable]="false" #createPopup>
  <div class="gp-modal-title">
    {{ 'TEAM_PLANNING.create_new_team' | translate }}
  </div>
  <form novalidate class="gp-modal-body clearfix">
    <div class="col-md-12">
      <label for="teamName">{{ 'TEAM_PLANNING.team_name' | translate }}</label>
      <input type="text" class="form-control" id="teamName" [formControl]="teamName">
    </div>
  </form>
  <div class="gp-modal-footer">
    <div class="btn-bar-wrapper">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button type="button" [disabled]="teamName.invalid"
                class="btn btn-dark p-x-md" (click)="createTeam()">
          {{ 'EMPLOYEE_FORM.submit' | translate }}
        </button>
        <button type="button" class="btn btn-secondary p-x-md" (click)="cancelCreateTeam(createPopup)">
          {{ 'FORMS.cancel' | translate }}
        </button>
      </div>
    </div>

  </div>
</gp-modal>

<ng-template #submenu let-employee>
  <ul *ngIf="(isTabletViewport || isMobileViewport); else multilevelMenu" class="dropdown-menu submenu">
    <li>
      <h3 class="dropdown-header">{{'MY_TEAM.team_management' | translate}}</h3>

      <h6 class="dropdown-header second-level">{{ 'TEAM_PLANNING.add_to_team' | translate }}</h6>
      <ul>
        <li class="dropdown-item" (click)="addContractToTeam(employee?.empContracts[0]?.id, team)" *ngFor="let team of teams">
          {{team.name}}
        </li>
        <li class="dropdown-item pointer"
            (click)="openCreateTeamModal(employee?.empContracts[0]?.id)"
            [ngClass]="{'button-separator': teams.length}">
          {{ 'TEAM_PLANNING.create_new_team' | translate }}
        </li>
      </ul>
    </li>
    <li *ngIf="isCustomTeam">
      <h6 class="dropdown-header second-level" (click)="removeContractFromTeam(selectedTeam, employee?.empContracts[0]?.id)">{{ 'TEAM_PLANNING.remove_from_team' | translate }}</h6>
    </li>
    <li *ngIf="menuItems.communications?.length || newOnboardingEnabled">
      <h3 class="dropdown-header">{{'EMPLOYEE_MANAGE.communication' | translate}}</h3>
      <ul>
        <li *ngFor="let communication of menuItems.communications | sortByTranslations:
                       triggerSortByTranslationPipe :['descriptionTransId'] | async"
            (click)="selectReportDefinition(communication)"
            class="dropdown-item">
          {{ communication.descriptionTransId | translate }}
        </li>
        <li *ngIf="newOnboardingEnabled" (click)="onSendOnboarding()" class="dropdown-item"
            [ngClass]="onboardingItemClasses" [tooltip]="onboardingTooltip" placement="right" container="body">
          <i aria-hidden="true"></i>
          <span>{{ 'Onboarding.send_onboarding' | translate }}</span>
        </li>
      </ul>
    </li>
  </ul>

  <ng-template #multilevelMenu>
    <ul class="dropdown-menu submenu">
      <li class="dropdown-item dropdown-submenu">
        <em class="fa fa-light fa-caret-right"></em>
        {{'MY_TEAM.team_management' | translate}}
        <ul class="dropdown-menu pointer">
          <li class="dropdown-item dropdown-submenu pointer">
            <a>{{ 'TEAM_PLANNING.add_to_team' | translate }}</a>
            <em class="fa fa-light fa-caret-right"></em>
            <ul class="dropdown-menu">
              <li class="dropdown-item" (click)="addContractToTeam(employee?.empContracts[0]?.id, team)" *ngFor="let team of teams">
                {{team.name}}
              </li>
              <li class="dropdown-item pointer text-primary"
                  (click)="openCreateTeamModal(employee?.empContracts[0]?.id)"
                  [ngClass]="{'button-separator': teams.length}">
                {{ 'TEAM_PLANNING.create_new_team' | translate }}
              </li>
            </ul>
          <li class="dropdown-item dropdown-submenu pointer" *ngIf="isCustomTeam" >
            <a (click)="removeContractFromTeam(selectedTeam, employee?.empContracts[0]?.id)">{{ 'TEAM_PLANNING.remove_from_team' | translate }}</a>
          </li>
        </ul>
      </li>
      <li class="dropdown-item dropdown-submenu" *ngIf="menuItems.communications?.length || newOnboardingEnabled">
        <em class="fa fa-light fa-caret-right"></em>
        {{'EMPLOYEE_MANAGE.communication' | translate}}
        <ul class="dropdown-menu pointer">
          <li *ngFor="let communication of menuItems.communications | sortByTranslations:
                         triggerSortByTranslationPipe :['descriptionTransId'] | async"
              (click)="selectReportDefinition(communication)"
              class="dropdown-item pointer">
            {{ communication.descriptionTransId | translate }}
          </li>
          <li *ngIf="newOnboardingEnabled" (click)="onSendOnboarding()" class="dropdown-item"
            [ngClass]="onboardingItemClasses" [tooltip]="onboardingTooltip" placement="right" container="body">
          <i aria-hidden="true"></i>
          <span>{{ 'Onboarding.send_onboarding' | translate }}</span>
        </li>
        </ul>
      </li>
    </ul>
  </ng-template>
</ng-template>

<gp-report-definition *ngIf="cliRegIds && contractId"
                      [cliRegIds]="cliRegIds"
                      [mySpaceCliRegId]="cliRegIds[0]"
                      [contractId]="contractId"
                      [hiddenValues]="hiddenValuesForReportDefinition"
                      [types]="availableReportType"
                      [profileType]="mssProfileType"
                      [selectedReportDefinition]="selectedReportDefinition"
                      (reportDefinitionsLoaded)="reportDefinitionsLoaded($event)"
                      (reportDefinitionListener)="reportDefinitionListener()"
                      [profileMode]="profileMode">
</gp-report-definition>
